import { StatCard, StatCardGrid } from '../../../components/common';
import { fmtCurrency, fmtGrams } from '../../../utils/formatNumber';
import { formatDate } from '../../../utils/dateUtils';
import styles from '../Reports.module.css';

export default function GoldRegisterReport({ data }) {
  if (!data) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <StatCardGrid cols={2}>
        <StatCard label="Total Grams" value={fmtGrams(data.totalGrams)} />
        <StatCard label="Total Value" value={fmtCurrency(data.totalInr)} valueColor="green" />
      </StatCardGrid>

      <div className="card">
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Receipt No</th>
                <th>Category</th>
                <th>Grams</th>
                <th>Purity</th>
                <th>Rate/g</th>
                <th className={styles.amtRight}>Value (₹)</th>
              </tr>
            </thead>
            <tbody>
              {(!data.receipts || data.receipts.length === 0) && (
                <tr><td colSpan={7} className="empty-state">No gold donations in period.</td></tr>
              )}
              {data.receipts?.map((r, i) => (
                <tr key={i}>
                  <td>{formatDate(r.date)}</td>
                  <td><code>{r.receiptNo}</code></td>
                  <td>{r.category}</td>
                  <td>{r.goldGrams}g</td>
                  <td>{r.goldPurity}K</td>
                  <td>{fmtCurrency(r.valuationRate)}</td>
                  <td className={styles.amtRight}>{fmtCurrency(r.amountInr)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
